import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getConnectorConfigurationsQueryKey } from "ConnectorConfigurations/Api/Queries/useConnectorConfigurationsQuery";
import type { CreateConnectorConfigurationCommand } from "Infrastructure/Api/Api";
import { postConnectorConfigurations } from "Infrastructure/Api/Api";

export function useCreateConnectorConfigurationMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (command: CreateConnectorConfigurationCommand) =>
			postConnectorConfigurations(command),
		onSuccess: () => {
			// Invalidate connector configurations query to refetch the list
			queryClient.invalidateQueries({
				queryKey: [getConnectorConfigurationsQueryKey(0, 100)],
			});
		},
	});
}
